$(document).ready(function() {
  $('#myTable').DataTable({
     destroy: true,
    "ordering":false
  });
});
